import { Button, Modal, Alert } from 'react-bootstrap';
import React from "react";
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';

import 'react-widgets/dist/css/react-widgets.css';
import { MultiSelectField, ReadonlyInput, WideField, SimpleField } from '../common/Inputs';

import * as fetchingState from '../../constants/fetchingState';

import { fetchCategories as fetchCategoriesAction } from '../../actions/categories';
import { FileInput } from '../common/FileInput';



const validate = values => {
    const errors = {};
    const required = (type) => {
        if (!values[type] || values[type].length === 0) {
            errors[type] = '*Обязательно для заполнения';
        }
    }
    required('Name');
    required('Categories');
    required('Price');
    required('Unit');
    required('CleaningTime');

    return errors;
};

let Edit = class extends React.Component {
    constructor(props) {
        super(props);
        this._handleSubmit = this._handleSubmit.bind(this);
    }

    componentDidMount() {
        const { categories, categoriesFetching, fetchCategoriesAction } = this.props;
        if (categoriesFetching !== fetchingState.FETCHING && categories.length === 0)
            fetchCategoriesAction();
    }

    _handleSubmit(values) {
        const { onSubmit } = this.props;

        const model = {
            ...values,
            Categories: undefined,
            CategoryIds: values.Categories.map(c => c.Id)
        };
        onSubmit(model);
    }

    render() {
        const { categories, fetching, initialValues: service, crudError, onClose, handleSubmit, isNew } = this.props;

        const formVisible = fetching === fetchingState.INITIAL;
        const closeButtonVisible = fetching === fetchingState.FETCHED || fetching === fetchingState.FAILED;

        return (
            <Modal show={true}>
                <Modal.Header>
                    <Modal.Title>{isNew ? 'Новая услуга' : 'Редактирование услуги'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {formVisible && <form className='form-horizontal' onSubmit={handleSubmit(this._handleSubmit)}>
                        {!isNew && <ReadonlyInput value={service.Id} label="Id" />}
                        <Field name="Name" component={SimpleField} label='Название' />

                        <Field
                            name="Categories"
                            component={MultiSelectField}
                            dataKey="Id"
                            textField="Name"
                            data={categories}
                            label="Категории" />
                        <Field name="Price" component={SimpleField} label='Цена' type='number' />
                        <Field name="Unit" component={SimpleField} label='Ед. измерения' />
                        <Field name="CleaningTime" component={SimpleField} label='Время чистки' type='number' />
                        <Field name="Insurance" component={SimpleField} min='0' label='Страховка' type='number' />
                        <Field name="Image" component={FileInput} label='Иконка' />
                        <Field name="IsActive" component={WideField} label='Активна' type='checkbox' />
                        <Field name="IsVisible" component={WideField} label='Отображать на сайте' type='checkbox' />
                    </form>}
                    {fetching === fetchingState.FETCHING &&
                        <Alert bsStyle='info'>Пожалуйста, подождите...</Alert>}
                    {fetching === fetchingState.FETCHED &&
                        <Alert bsStyle='success'>УСПЕХ!</Alert>}
                    {fetching === fetchingState.FAILED &&
                        <Alert bsStyle='danger'>
                            <p>ОШИБКА!</p>
                            <p>crudError</p>
                        </Alert>}
                </Modal.Body>
                {formVisible && <Modal.Footer>
                    <Button bsStyle="success" type="submit" onClick={handleSubmit(this._handleSubmit)}>Сохранить</Button>
                    <Button type="button" onClick={onClose}>Отмена</Button>
                </Modal.Footer>}
                {closeButtonVisible &&
                    <Modal.Footer>
                        <Button type="button" onClick={onClose}>
                            Закрыть
                        </Button>
                    </Modal.Footer>}
            </Modal>
        );
    }
}

Edit = reduxForm({
    form: 'serviceEdit',
    validate
})(Edit);

Edit = connect((state, props) => {
    const category = state.application.get('serviceCategory').get('category');
    return {
        categories: category.categories.filter(c => c.IsActive),
        categoriesFetching: category.fetching,
        result: props.isNew ? category.createResult : category.updateResult
    };
}, { fetchCategoriesAction })(Edit);

export default Edit;


// WEBPACK FOOTER //
// ./src/components/services/ServiceEditModal.jsx